import { render, staticRenderFns } from "./about-img.vue?vue&type=template&id=93c7fb60&scoped=true&"
import script from "./about-img.vue?vue&type=script&lang=js&"
export * from "./about-img.vue?vue&type=script&lang=js&"
import style0 from "./about-img.vue?vue&type=style&index=0&id=93c7fb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c7fb60",
  null
  
)

export default component.exports